import { formatCurrency, IjmSelection } from "../../../utils";
import { useI18n } from "../../../hooks/i18n-hooks";
import { useCallback } from "react";
import { Cct } from "../../../__generated__/graphql";
import { IjmGroupFieldFragment } from "../../../__generated__/operations/graphql";
import { useIJMEditorContext } from "./context";

export const isSelectionValid = (
    selection?: IjmSelection,
    cct?: Cct,
    useLse?: boolean,
): boolean => {
    if (useLse || (cct && cct.isIjmMandatory) || !!selection?.ijmGroupId) {
        return (
            selection?.ijmGroupId !== undefined &&
            selection?.ijmGroupId !== null &&
            (!useLse ||
                (selection?.ijmPayFirstDays !== undefined &&
                    selection?.ijmPayFirstDays !== null)) &&
            selection?.ijmPayRemainingPercents !== undefined &&
            selection?.ijmPayRemainingPercents !== null
        );
    }
    return selection?.ijmGroupId !== undefined;
};

export const getPayFirstDaysChoices = () => {
    return [
        { label: "ijm.ijm_pay_first_days.select.yes", value: true },
        { label: "ijm.ijm_pay_first_days.select.no", value: false },
    ];
};

export const getPayFirstDaysSetAndLabel = (key: boolean | null | undefined): [boolean, string] => {
    if (key === null || key === undefined) {
        return [false, "ijm.ijm_pay_first_days.select.place_holder"];
    } else if (key) {
        return [true, "ijm.ijm_pay_first_days.select.yes"];
    } else {
        return [true, "ijm.ijm_pay_first_days.select.no"];
    }
};

export const getPayRemainingPercentsChoices = () => {
    return [
        { label: "ijm.ijm_pay_remaining_percents.select.20", value: 20 },
        { label: "ijm.ijm_pay_remaining_percents.select.10", value: 10 },
        { label: "ijm.ijm_pay_remaining_percents.select.0", value: 0 },
    ];
};

export const getPayRemainingPercentsSetAndLabel = (
    key: number | null | undefined,
): [boolean, string] => {
    if (key === null || key === undefined) {
        return [false, "ijm.ijm_pay_remaining_percents.select.place_holder"];
    } else if (key === 0) {
        return [true, "ijm.ijm_pay_remaining_percents.select.0"];
    } else if (key === 10) {
        return [true, "ijm.ijm_pay_remaining_percents.select.10"];
    } else if (key === 20) {
        return [true, "ijm.ijm_pay_remaining_percents.select.20"];
    }
    return [true, `${key} %`];
};

export const useBuildGroupInfo = (useLse: boolean = false) => {
    const i18n = useI18n();
    const { salaryInfo } = useIJMEditorContext();
    return useCallback(
        (group: IjmGroupFieldFragment) => {
            const days = group.waitingPeriodDays;
            const startingDay = days + 1;
            // in LSE we have 2 jour de carence. so employer pay from day 3. in no lse he pay from 1st day
            const payFromDay = useLse ? 3 : 1;
            const ret = [i18n.t("ijm.data.descriptions.item_1", { count: startingDay })];
            if (payFromDay < days) {
                ret.push(i18n.t("ijm.data.descriptions.item_2", { payFromDay, payToDay: days }));
            } else {
                ret.push(i18n.t("ijm.data.descriptions.item_2_nothing_to_pay"));
            }
            if (salaryInfo) {
                const salary = salaryInfo.amount;
                const amount = (salary * Number(group.clientRate)) / 100.0;
                const amountDisplay = i18n.t(`mission.salary_${salaryInfo.earningType}`, {
                    value: formatCurrency({ amountInCents: amount }),
                });

                ret.push(
                    i18n.t("ijm.data.descriptions.item_3", {
                        percent: group.clientRate,
                        amount: amountDisplay,
                    }),
                );
            } else {
                ret.push(
                    i18n.t("ijm.data.descriptions.item_3b", {
                        percent: group.clientRate,
                    }),
                );
            }
            return ret;
        },
        [salaryInfo, i18n, useLse],
    );
};
